<template>
  <div>
    <div class="comp-top-wrapper">
      <div class="landing-wrapper">
        <div class="landing-container">
          <div class="row" style="padding: 2rem 0">
            <div
              class="col-4 col-sm-6 col-md-6 col-lg-3 col-xl-2 image-wrapper"
            >
              <img class="image" :src="company_info.image_url" />
            </div>
            <div
              class="col-8 col-sm-6 col-md-6 col-lg-9 col-xl-10"
              style="padding:0"
            >
              <div style="text-align: left; font-size: 3rem; font-weight: bold">
                {{ company_info.company_name }}
              </div>
              <div style="text-align: left; font-size: 1.6rem;">
                {{ company_info.category }}
              </div>
              <div style="text-align: left; margin-top: 1rem">
                <!--<span style="margin-right: 1rem"><v-icon color="#4e4098">mdi-account-group</v-icon></span>-->
                <!--<span style="margin-right: 2rem">1 Open Position(s)</span>-->
                <span
                  v-if="company_info.location_name"
                  style="margin-right: 0.5rem"
                  ><v-icon color="#4e4098">mdi-map-marker</v-icon></span
                >
                <span style="margin-right: 2rem">{{
                  company_info.location_name
                }}</span>
                <span v-if="company_info.website" style="margin-right: 0.5rem"
                  ><v-icon color="#4e4098">mdi-link</v-icon></span
                >
                <span style="margin-right: 1rem">
                  <a target="_blank" :href="urlWebsite">{{
                    company_info.website
                  }}</a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="margin-top: 5rem">
      <div class="landing-wrapper">
        <div class="landing-container">
          <div class="row" style="min-height: 41.6vh;">
            <div
              class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-8"
              style="padding-right: 10rem"
            >
              <div
                v-if="company_info.company_description"
                class="about-section"
              >
                <div class="title-sec">
                  <span
                    style="border-left: 2px solid #00adee; margin-right: 10px"
                  ></span
                  ><span>About</span>
                </div>
                <div style="text-align: left; margin-top: 2rem">
                  {{ company_info.company_description }}
                </div>
              </div>
              <div
                v-if="jobs.length > 0"
                class="about-section"
                style="margin-top: 8rem"
              >
                <div class="title-sec">
                  <span
                    style="border-left: 2px solid #00adee; margin-right: 10px"
                  ></span
                  ><span>Jobs From {{ company_info.company_name }}</span>
                </div>
                <div
                  :key="index"
                  v-for="(job, index) in jobs"
                  class="row job-des"
                >
                  <div
                    class="col-4 col-sm-12 col-md-4 col-lg-3 col-xl-2 image-small"
                  >
                    <img
                      class="image"
                      style="border-right: 1px solid #e0e0e0; padding: 10px"
                      :src="company_info.image_url"
                    />
                  </div>
                  <div
                    class="col-4 col-sm-6 col-md-4 col-lg-6 col-xl-7 "
                    style="text-align: left; padding: 1rem 0"
                  >
                    <div style="font-weight: bold">{{ job.job_title }}</div>
                    <div style="font-size: 1.2rem">
                      {{ MONTH_DATE_FORMAT(job.close_date) }}
                    </div>
                  </div>
                  <!--<div class="col-3 col-sm-6 col-md-4 col-lg-2 col-xl-2 " style="padding: 1rem 0; margin: auto">-->
                  <!--<div>-->
                  <!--<span style="background-color: #e9e9e9; color: #4aab7a; padding: 2px 5px">Full Time</span>-->
                  <!--</div>-->
                  <!--<div style="font-size: 1.2rem">55,000BDT/month</div>-->
                  <!--</div>-->
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-4">
              <div v-if="company_info.company_size" class="about-section">
                <div class="title-sec">
                  <span
                    style="border-left: 2px solid #00adee; margin-right: 10px"
                  ></span
                  ><span>Company Information</span>
                </div>
                <div style="text-align: left; margin-top: 2rem">
                  <!--<div class="row" style="margin-top: 2rem !important;">-->
                  <!--<div class="col-1 no-padding">-->
                  <!--<img style="margin-top: 5px" src="../../assets/static_content/multiple.svg">-->
                  <!--</div>-->
                  <!--<div class="col-6">-->
                  <!--<div>Posted Jobs</div>-->
                  <!--<div>30</div>-->
                  <!--</div>-->
                  <!--</div>-->
                  <!--<div class="row" style="margin-top: 2rem !important;">-->
                  <!--<div class="col-1 no-padding">-->
                  <!--<img style="margin-top: 6px" src="../../assets/static_content/clock.svg">-->
                  <!--</div>-->
                  <!--<div class="col-6">-->
                  <!--<div>Since</div>-->
                  <!--<div>July 19, 2018</div>-->
                  <!--</div>-->
                  <!--</div>-->
                  <div
                    v-if="company_info.company_size"
                    class="row"
                    style="margin-top: 2rem !important;"
                  >
                    <div class="col-1 no-padding">
                      <img
                        style="margin-top: 5px"
                        src="../../assets/static_content/building.svg"
                      />
                    </div>
                    <div class="col-6">
                      <div>Company Size</div>
                      <div>{{ company_info.company_size }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <!--<div class="about-section" style="margin-top: 8rem">-->
              <!--<div class="title-sec">-->
              <!--<span style="border-left: 2px solid #00adee; margin-right: 10px"></span><span>Benefits</span>-->
              <!--</div>-->
              <!--<div style="text-align: left; margin-top: 0.5rem">-->
              <!--<v-icon color="#4e4098" style="margin-right: 0.5rem">mdi-check</v-icon> <span>Weekly two holidays</span>-->
              <!--</div>-->
              <!--<div style="text-align: left; margin-top: 0.5rem">-->
              <!--<v-icon color="#4e4098" style="margin-right: 0.5rem">mdi-check</v-icon><span>Two festival bonus</span>-->
              <!--</div>-->
              <!--<div style="text-align: left; margin-top: 0.5rem">-->
              <!--<v-icon color="#4e4098" style="margin-right: 0.5rem">mdi-check</v-icon><span>TA/DA, Mobile bill</span>-->
              <!--</div>-->
              <!--</div>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GET_COMPANY_DETAILS } from "../../Api/public_api";
import { JOBS_FROM_SAME_COMPANY } from "../../Api/common_api";
import { MONTH_DATE_FORMAT } from "../../globalFunctions";

export default {
  name: "company-details-component",
  props: {
    id: String
  },
  data: function() {
    return {
      company_id: null,
      company_info: {},
      urlWebsite: "",
      jobs: [],
      MONTH_DATE_FORMAT: MONTH_DATE_FORMAT
    };
  },
  methods: {
    getDetails() {
      const self = this;
      let data = {
        company_id: self.company_id,
        image: true
      };
      GET_COMPANY_DETAILS(data)
        .then(function(data) {
          self.company_info = data;
          if (!data.website.includes("http")) {
            self.urlWebsite = "https://" + data.website;
          } else {
            self.urlWebsite = data.website;
          }
        })
        .catch();
    },
    getPublishedJobs() {
      const self = this;
      JOBS_FROM_SAME_COMPANY(self.company_id)
        .then(function(data) {
          self.jobs = data.jobs;
        })
        .catch();
    }
  },
  mounted() {
    const self = this;
    if (self.id) {
      self.company_id = self.id;
      self.getDetails();
      self.getPublishedJobs();
    }
  }
};
</script>

<style scoped>
.comp-top-wrapper {
  background-color: #f2f3f8;
}
.image-wrapper {
  width: 11rem;
  margin: 1rem 0;
}
.image {
  width: inherit;
  height: auto;
  float: left;
  margin: auto;
}
.title-sec {
  text-align: left;
  font-size: 2rem;
}
.job-des {
  margin-top: 2rem !important;
  border: 1px solid #e0e0e0;
}
.image-small {
  padding: 0;
  width: 10rem;
}
</style>
